import { defineComponent as E, ref as i, watch as b, nextTick as L, onUnmounted as V, resolveComponent as A, openBlock as w, createBlock as O, Teleport as T, createElementVNode as m, withKeys as $, createVNode as h, Transition as y, withCtx as f, createElementBlock as v, createCommentVNode as g, normalizeStyle as M, renderSlot as C, normalizeClass as q } from "vue";
import { V as N, C as k } from "../../../VDrawerHeader-7bf1d917.js";
import { _ as K } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../../VHeadline.vue_vue_type_script_lang-186a5340.js";
import "../../../composables/useShowPriceDisclaimer.js";
import "../../../composables/useSpacingClass.js";
import "../../atoms/VIconButton/VIconButton.js";
import "../../atoms/VIcon/VIcon.js";
import "../../../utils/getComputedStyleValue.js";
const U = (e) => {
  var r, d, s;
  const t = (r = e.value) == null ? void 0 : r.getClientRects();
  return !!((d = e.value) != null && d.offsetWidth) || !!((s = e.value) != null && s.offsetHeight) || (t == null ? void 0 : t.length) === 1;
}, j = E({
  name: "VDrawer",
  components: {
    VDrawerHeader: N
  },
  props: {
    /**
     * Used to link it with aria-controls
     */
    id: {
      type: String
    },
    /**
     * flag telling if the drawer is open
     */
    isOpen: {
      type: Boolean,
      required: !0
    },
    /**
     * title at top of the drawer
     */
    title: {
      type: String,
      default: void 0
    },
    /**
     * flag telling if the header of the drawer is visible
     */
    showHeader: {
      type: Boolean,
      default: !0
    },
    /**
     * flag telling if the back button is visible
     */
    showBack: {
      type: Boolean,
      default: !1
    },
    /**
     * flag telling if the close button is visible
     */
    showClose: {
      type: Boolean,
      default: !0
    },
    /**
     * flag telling if the content of the drawer has padding
     */
    hasContentPadding: {
      type: Boolean,
      default: !0
    },
    /**
     * Ref to the element that should gain focus after closing the drawer.
     * Normally this should be the element that opened the drawer.
     * If not provided will focus body.
     */
    focusElementAfterClose: {
      type: Object,
      default: null
    },
    /**
     * Defines the color style of title, back and close button
     */
    headerColorStyle: {
      type: String,
      default: k.DARK
    },
    /**
     * additional class to be added to the drawer header
     */
    headerClass: {
      type: String,
      default: ""
    },
    headerStyle: {
      type: Object,
      default: null
    },
    backAriaLabel: {
      type: String,
      default: "Back"
    },
    closeAriaLabel: {
      type: String,
      default: "Close"
    }
  },
  emits: [
    "drawer:close",
    "drawer:back",
    "drawer:scroll-change",
    "drawer:scroll-ref"
  ],
  data() {
    return {
      ColorMode: k
    };
  },
  slots: {
    "header-extension": {
      description: "Use this slot for the header of the drawer"
    },
    content: {
      description: "Use this slot for the content of the drawer"
    }
  },
  setup(e, { emit: t }) {
    const r = i(
      "hobi-drawer__body--no-scroll-" + Date.now()
    ), d = () => {
      var a;
      const o = document.createElement("style");
      o.id = r.value, o.innerHTML = `.${r.value} { overflow: hidden !important;}`, (a = document.querySelector("head")) == null || a.appendChild(o);
    }, s = (o) => {
      const a = document.querySelector("body");
      o ? a == null || a.classList.add(r.value) : a == null || a.classList.remove(r.value);
    };
    d(), s(e.isOpen);
    const u = (o) => {
      if (!U(o)) {
        console.log(
          "[VDrawer._focusElement()]: Cant focus an element that is not visible. Element was:",
          o.value
        );
        return;
      }
      o.value && o.value.focus && o.value.focus({
        preventScroll: !0
      });
    }, n = i(null);
    b(
      () => e.isOpen,
      async (o) => {
        if (s(o), o)
          await L(), u(n);
        else if (e.focusElementAfterClose) {
          const a = i(e.focusElementAfterClose);
          u(a);
        }
      }
    ), V(() => {
      var a;
      const o = document.getElementById(r.value);
      o && ((a = document.querySelector("head")) == null || a.removeChild(o));
    });
    const l = 22, S = 77, c = i(!1), B = (o) => {
      const a = o.target.scrollTop > (c.value ? l : S);
      a !== c.value && t("drawer:scroll-change", a), c.value = a;
    }, D = () => {
      t("drawer:close");
    }, H = () => {
      t("drawer:back");
    }, p = i(!1);
    return window.matchMedia("(max-width: 415px)").addEventListener("change", (o) => {
      p.value = o.matches;
    }), b(
      () => n.value,
      () => {
        t("drawer:scroll-ref", n.value);
      }
    ), {
      handleClose: D,
      handleBack: H,
      handleScroll: B,
      bodyScrollLockClassName: r,
      drawer: n,
      isScrolled: c,
      isMobile: p
    };
  }
});
const z = ["id"];
function I(e, t, r, d, s, u) {
  const n = A("VDrawerHeader");
  return w(), O(T, {
    to: "body",
    disabled: e.isMobile
  }, [
    m("div", {
      "aria-modal": "true",
      role: "dialog",
      id: e.id,
      tabindex: "-1",
      "aria-labelledby": "hobi-drawer-headline",
      onKeydown: t[2] || (t[2] = $((...l) => e.handleClose && e.handleClose(...l), ["esc"]))
    }, [
      h(y, { name: "anim-hobi-fade-drawer-background" }, {
        default: f(() => [
          e.isOpen ? (w(), v("div", {
            key: 0,
            class: "hobi-drawer-background tw-fixed tw-top-0 tw-bottom-0 tw-left-0 tw-right-0 tw-bg-gray-900 tw-bg-opacity-60",
            onClick: t[0] || (t[0] = (...l) => e.handleClose && e.handleClose(...l))
          })) : g("", !0)
        ]),
        _: 1
      }),
      h(y, { name: "anim-hobi-drawer" }, {
        default: f(() => [
          e.isOpen ? (w(), v("div", {
            key: 0,
            "data-testid": "hobi-drawer",
            class: "hobi-drawer tw-fixed tw-top-0 tw-bottom-0 tw-right-0 tw-overflow-y-scroll tw-overflow-x-hidden tw-rounded-none tw-bg-white tw-w-full tw-h-full focus:tw-border-transparent focus:tw-outline-transparent",
            ref: "drawer",
            onScroll: t[1] || (t[1] = (...l) => e.handleScroll && e.handleScroll(...l)),
            tabindex: "-1"
          }, [
            h(n, {
              title: e.title,
              "show-header": e.showHeader,
              "show-back": e.showBack,
              "show-close": e.showClose,
              "header-color-style": e.headerColorStyle,
              "onDrawerHeader:back": e.handleBack,
              "onDrawerHeader:close": e.handleClose,
              "is-scrolled": e.isScrolled,
              "header-class": e.headerClass,
              style: M(e.headerStyle),
              "back-aria-label": e.backAriaLabel,
              "close-aria-label": e.closeAriaLabel
            }, {
              "header-extension": f(() => [
                C(e.$slots, "header-extension", {}, void 0, !0)
              ]),
              _: 3
            }, 8, ["title", "show-header", "show-back", "show-close", "header-color-style", "onDrawerHeader:back", "onDrawerHeader:close", "is-scrolled", "header-class", "style", "back-aria-label", "close-aria-label"]),
            m("div", {
              class: q([
                "hobi-content-drawer tw-relative tw-h-auto",
                e.hasContentPadding ? "hobi-content-drawer--padding tw-p-6 tw-pb-0" : ""
              ])
            }, [
              C(e.$slots, "content", {}, void 0, !0)
            ], 2)
          ], 544)) : g("", !0)
        ]),
        _: 3
      })
    ], 40, z)
  ], 8, ["disabled"]);
}
const Z = /* @__PURE__ */ K(j, [["render", I], ["__scopeId", "data-v-2d375730"]]);
export {
  Z as default
};
